var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"md":"6"}},[_c('b-card',{attrs:{"title":"Top 10 Produtos Mais Faturados no Período."}},[_c('app-echart-bar',{ref:"refBarChartbar",attrs:{"option-data":_vm.option}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }